import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#ffffff'
    }}>
      {/* Page Banner */}
      <div style={{
        background: 'linear-gradient(135deg, #03A84A 0%, #028A3F 100%)',
        padding: '80px 20px 60px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 2
        }}>
          <h1 style={{
            color: '#ffffff',
            fontSize: '48px',
            fontWeight: 700,
            marginBottom: '20px',
            fontFamily: 'Quicksand, sans-serif'
          }}>
            404 Error
          </h1>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            fontSize: '16px',
            color: '#ffffff'
          }}>
            <Link 
              to="/" 
              style={{
                color: '#ffffff',
                textDecoration: 'none',
                transition: 'opacity 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              Home
            </Link>
            <span style={{ color: '#ffffff' }}>/</span>
            <span style={{ color: '#D1FAE5' }}>404</span>
          </div>
        </div>
        
        {/* Decorative shapes */}
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          animation: 'float 6s ease-in-out infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '30px',
          left: '30px',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.08)',
          animation: 'float 8s ease-in-out infinite'
        }}></div>
      </div>

      {/* Error Section */}
      <div style={{
        flex: 1,
        padding: '120px 20px',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          {/* 404 Image */}
          <div style={{
            marginBottom: '60px'
          }}>
            <img 
              src="/assets/images/error/404.png" 
              alt="404 Error"
              style={{
                maxWidth: '100%',
                height: 'auto',
                animation: 'bounce 2s ease-in-out infinite'
              }}
            />
          </div>

          {/* Error Message */}
          <h2 style={{
            fontSize: '36px',
            fontWeight: 700,
            color: '#252525',
            marginBottom: '20px',
            fontFamily: 'Quicksand, sans-serif',
            lineHeight: '1.4'
          }}>
            Whoops! This Page Got Lost
          </h2>

          <p style={{
            fontSize: '18px',
            color: '#797979',
            marginBottom: '50px',
            lineHeight: '1.6'
          }}>
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>

          {/* Go Back Home Button */}
          <Link
            to="/"
            style={{
              display: 'inline-block',
              padding: '16px 40px',
              backgroundColor: '#03A84A',
              color: '#ffffff',
              fontSize: '16px',
              fontWeight: 600,
              textDecoration: 'none',
              borderRadius: '8px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(3, 168, 74, 0.2)',
              fontFamily: 'DM Sans, sans-serif',
              letterSpacing: '0.5px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#028A3F';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(3, 168, 74, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#03A84A';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(3, 168, 74, 0.2)';
            }}
          >
            GO BACK HOME
          </Link>
        </div>
      </div>

      {/* Add keyframe animations */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 36px !important;
          }
          h2 {
            font-size: 28px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;
